import {createGlobalStyle} from 'styled-components'

const Fonts = createGlobalStyle`
  .font-accent {color: ${props => props?.theme?.colors?.text?.accent} !important}
  .font-bold {font-weight: bold}
`

export default Fonts
